import React, {useEffect, useRef, useState} from 'react';

// 이미지 임포트 (실제 이미지 경로로 변경 필요)
import phoneImage from '../../../assets/images/about/section_02_subsection_01_item.png';

const AboutSubSection0201: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: window.innerWidth <= 1024 ? 0.08 : 0.2, // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-50px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className={`container text-black pt-[80px] md:pt-[128px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="hidden lg:block mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 텍스트, 오른쪽 이미지 */}
        <div className="flex flex-col md:flex-row items-center justify-between lg:gap-8 xl:gap-16 2xl:gap-32">
          {/* 왼쪽: 통계 정보 */}
          <div className="w-1/2">
            {/* 섹션 제목 */}
            <p className="text-lg md:text-xl font-semibold mb-[40px] md:mb-[72px]">
              PONPISH, 컬러렌즈 플랫폼
            </p>
            <span className="text-28 md:text-40 leading-[1.4] font-bold mb-4 md:mb-8">
              AR·AI 기반 컬러렌즈 플랫폼,<br/>
            </span>
            <span className="text-28 md:text-40 leading-[1.4] font-bold mb-4 md:mb-8">
              스마트한 쇼핑 경험을 완성하다
            </span>

            <p className="text-base md:text-xl font-normal leading-[1.6] my-[40px] md:my-[72px]">
              맞춤 추천과 실시간 착용 시뮬레이션으로 렌즈 쇼핑의 새로운 기준을 제시합니다.<br/>
              앱 하나로 비교, 착용, 구매까지 완결된 컬러렌즈 커머스를 제공합니다.
            </p>
            {/* 통계 그리드 */}
            <div className="flex gap-4 text-white">
              {/* 회원수 */}
              <div
                className="aspect-square bg-black rounded-[5px] w-full max-w-[170px] flex flex-col items-center justify-center">
                <p className="text-sm md:text-base font-semibold">MEMBERS</p>
                <span className="text-54 font-bold">120<span className="text-34 font-bold">K</span></span>
              </div>

              {/* 월 활성 사용자 */}
              <div
                className="aspect-square bg-black rounded-[5px] w-full max-w-[170px] flex flex-col items-center justify-center">
                <p className="text-sm md:text-base font-semibold">MAU</p>
                <span className="text-54 font-bold">300<span className="text-34 font-bold">K</span></span>
              </div>

              {/* 컬러렌즈 종류 */}
              <div
                className="aspect-square bg-black rounded-[5px] w-full max-w-[170px] flex flex-col items-center justify-center">
                <p className="text-sm md:text-base font-semibold">LENS</p>
                <span className="text-54 font-bold">200</span>
              </div>

              {/* 연간 매출 */}
              <div
                className="aspect-square bg-black rounded-[5px] w-full max-w-[170px] flex flex-col items-center justify-center">
                <p className="text-sm md:text-base font-semibold">REVENUE</p>
                <span className="text-54 font-bold">7.8<span className="text-34 font-bold">M</span></span>
              </div>
            </div>
          </div>

          {/* 오른쪽: 폰 이미지 */}
          <div className="w-1/2">
            <div className="flex justify-center">
              <img
                src={phoneImage}
                alt="폰뷰 앱 화면"
                className="max-w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="lg:hidden mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 텍스트, 오른쪽 이미지 */}
        <div className="flex flex-col items-center justify-center">
          {/* 왼쪽: 통계 정보 */}
          <p className="text-2xl md:text-4xl font-semibold mb-[30px] md:mb-[50px]">
            PONPISH, 컬러렌즈 플랫폼
          </p>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold md:mb-4">
              AR·AI 기반 컬러렌즈 플랫폼,<br/>
            </span>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold">
              스마트한 쇼핑 경험을 완성하다
          </span>

          <img
            src={phoneImage}
            alt="폰뷰 앱 화면"
            className="w-4/5 h-auto my-[30px] md:my-[50px]"
          />

          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            맞춤 추천과 실시간 착용 시뮬레이션으로</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            렌즈 쇼핑의 새로운 기준을 제시합니다.</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            앱 하나로 비교, 착용, 구매까지 </p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            완결된 컬러렌즈 커머스를 제공합니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSubSection0201;